import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import AddDiscordWidget from './components/AddDiscordWidget';

app.initializers.add('justoverclock/discord-widget', () => {
  extend(IndexPage.prototype, 'view', function (vdom) {
    if (vdom.children && vdom.children.splice) {
      const insert = <AddDiscordWidget />;
      vdom.children.splice(1, 0, insert);
    }
  });
});
